import { MessageTemplateEditPage } from './messageTemplate.edit.page';

export default MessageTemplateEditPage;
